import {drilldownTrendDataLoader} from '../../../../util/dataLoader';
import {withTimeout} from '../../../../util/http/withTimeout';
import {ITrendComponentAPIResponse} from './trendComponentSlice';

export function getaTrendData(filters): Promise<ITrendComponentAPIResponse> {
  const controller = new AbortController();
  return withTimeout(
    drilldownTrendDataLoader.get(filters, controller) as Promise<ITrendComponentAPIResponse>,
    controller
  );
}
